<form [formGroup]="recordForm" class="flex flex-col flex-1-0-auto">
  <div class="w-n-600 flex flex-col">
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Select Parent Entity</mat-label>
        <mat-select formControlName="selectedEntity" required>
          <mat-option *ngFor="let entity of entities" [value]="entity.id">{{entity.entity}}</mat-option>
        </mat-select>
        <mat-error *ngIf="recordFormError.selectedEntity.required">
          Entity is required!
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Record Type</mat-label>
        <mat-select (selectionChange)="onRecordTypeChanged($event)" formControlName="recordType" required>
          <mat-option [value]="'Person'">Person</mat-option>
          <mat-option [value]="'Organisation'">Organisation</mat-option>
        </mat-select>
        <mat-error *ngIf="recordFormError.recordType.required">
          Record Type is required!
        </mat-error>
      </mat-form-field>
    </div>
    <div *ngIf="recordForm.value.recordType && recordForm.value.recordType === 'Person'"
         formGroupName="personForm"
         class="flex flex-col flex-1-0-auto">
      <div class="flex flex-row justify-start items-start auto-flex">
        <mat-form-field appearance="outline" class="w-p-100">
          <mat-label>First Name</mat-label>
          <input formControlName="FirstName_6_p" matInput placeholder="" required
                 particleAnalytics
                 analyticsAction="FirstName_6_p-input"
          />
          <mat-error *ngIf="recordFormError.personForm.FirstName_6_p.required">
            First Name is required!
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-row justify-start items-start auto-flex">
        <mat-form-field appearance="outline" class="w-p-100">
          <mat-label>Last Name</mat-label>
          <input formControlName="LastName_6_p" matInput placeholder="" required
                 particleAnalytics
                 analyticsAction="LastName_6_p-input"
          />
          <mat-error *ngIf="recordFormError.personForm.LastName_6_p.required">
            Last Name is required!
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-row justify-start items-start auto-flex">
        <mat-form-field appearance="outline" class="orbitax-date-picker flex-0-0-100">
          <mat-label>Date of birth</mat-label>
          <input required formControlName="DateOfBirth_6_p" matInput [matDatepicker]="picker1" placeholder=""
                 particleAnalytics
                 analyticsCategory="date-time-cell"
                 analyticsAction="date-picker">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
          <mat-error *ngIf="recordFormError.personForm.DateOfBirth_6_p.required">
            Date of birth is required!
          </mat-error>
        </mat-form-field>
      </div>
      <!--<div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
        <mat-form-field appearance="outline" class="w-p-100">
          <mat-label>Place of birth</mat-label>
          <input formControlName="PlaceOfBirth_6_p" matInput placeholder="" required
                 particleAnalytics
                 analyticsAction= "Suffix_6_p-input"
          />
          <mat-error *ngIf="recordFormError.personForm.PlaceOfBirth_6_p.required">
            Place of birth is required!
          </mat-error>
        </mat-form-field>

      </div>-->
      <div class="flex flex-row justify-start items-start auto-flex">
        <mat-form-field appearance="outline" class="flex-0-0-100">
          <mat-label>Place of Birth</mat-label>
          <mat-select formControlName="PlaceOfBirth_6_p" required>
            <mat-option *ngFor="let country of countryList" [value]="country.code">
              {{country.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="recordFormError.personForm.PlaceOfBirth_6_p.required">
            Place of Birth is required!
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-row justify-start items-start auto-flex">
        <mat-form-field appearance="outline" class="flex-0-0-100">
          <mat-label>Country of Residence</mat-label>
          <mat-select formControlName="ResidenceCountryCode_11_p" required>
            <mat-option *ngFor="let country of countryList" [value]="country.code">
              {{country.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="recordFormError.personForm.ResidenceCountryCode_11_p.required">
            Country of Residence is required!
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="recordForm.value.recordType && recordForm.value.recordType === 'Organisation'"
         formGroupName="organisationForm"
         class="flex flex-col flex-1-0-auto">
      <!--<div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto" >
        <mat-form-field appearance="outline" class="w-p-100">
          <mat-label>Organisation Name</mat-label>
          <input formControlName="OrganisationName_6_p" matInput placeholder="" required
                 particleAnalytics
                 analyticsAction= "OrganisationName_6_p-input"
          />
          <mat-error *ngIf="recordFormError.organisationForm.OrganisationName_6_p.required">
            Organisation Name is required!
          </mat-error>
        </mat-form-field>
      </div>-->
      <div class="flex flex-row justify-start items-start auto-flex">
        <mat-form-field appearance="outline" class="flex-0-0-100">
          <mat-label>Organisation Name</mat-label>
          <mat-select (selectionChange)="onSelectRTP($event)" formControlName="OrganisationName_6_p" required>
            <mat-option *ngFor="let releventTaxpayer of releventTaxpayers" [value]="releventTaxpayer.entityName">
              {{releventTaxpayer.entityName}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="recordFormError.organisationForm.OrganisationName_6_p.required">
            Organisation Name is required!
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-row justify-start items-start auto-flex">
        <mat-form-field appearance="outline" class="w-p-100">
          <mat-label>Organisation Code</mat-label>
          <input formControlName="EntityCode" matInput placeholder=""
                 particleAnalytics
                 analyticsAction="EntityCode-input"
          />
        </mat-form-field>
      </div>
      <div class="flex flex-row justify-start items-start auto-flex">
        <mat-form-field appearance="outline" class="flex-0-0-100">
          <mat-label>Country of Residence</mat-label>
          <mat-select formControlName="ResidenceCountryCode_12_p" required>
            <mat-option *ngFor="let country of countryList" [value]="country.code">
              {{country.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="recordFormError.organisationForm.ResidenceCountryCode_12_p.required">
            Country of Residence is required!
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Ownership</mat-label>
        <input formControlName="Ownership_1_p" matInput placeholder=""
               particleAnalytics
               [errorStateMatcher]="errorMatcher"
               analyticsAction="Ownership_1_p-input"
        />
        <mat-error *ngIf="recordFormError.Ownership_1_p.containsAlphabet">
          Ownership should be a number.
        </mat-error>
        <mat-error *ngIf="recordFormError.Ownership_1_p.invalidOwnership">
          Total Ownership amount should be between 0 and 100.
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-start auto-flex">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>Invested Amount</mat-label>
        <input formControlName="InvestmentAmount_1_p" matInput placeholder=""
               particleAnalytics
               [errorStateMatcher]="errorMatcher"
               analyticsAction="InvestmentAmount_1_p-input"
        />
        <mat-error *ngIf="recordFormError.InvestmentAmount_1_p.containsAlphabet">
          InvestmentAmount should be a number.
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>
